import React from 'react';

import { useChatUnreadRoomsCount, useChatUnreadTotal } from 'modules/ChatV2/api/queries';

import styles from './ChatUnreadBadge.module.scss';

type ChatUnreadBadgeProps = {
  accent?: 'student' | 'teacher';
};

export const ChatUnreadBadge: React.FC<ChatUnreadBadgeProps> = ({ accent = 'student' }) => {
  const unread = useChatUnreadRoomsCount();
  const messages = useChatUnreadTotal();

  if (unread <= 0) {
    return null;
  }

  return (
    <span
      className={`${styles.badge} ${accent === 'teacher' ? styles.badgeTeacher : styles.badgeStudent}`}
      aria-label={`Чатов с непрочитанными: ${unread}`}
      title={`Непрочитанных сообщений: ${messages}`}
    >
      {unread > 9 ? '9+' : unread}
    </span>
  );
};
